import React from 'react';
import './../index.css';
import apiurl from './../apiurl';
import axios from 'axios';
import swal from 'sweetalert';




export default class PanelKonf extends React.Component {

  constructor() {
    super();    

    this.state = {

    };

  }

  






  render() {

    const { dane, idx, token, years } = this.props;
    const headID = 'head' + idx;
    const colapseID = 'collapse' + idx;

    return (
    <React.Fragment>
      <div class="card mb-2">
        <div class="card-header" id={headID}>
          <h2 class="mb-0"><button class="btn btn-block text-left" type="button" data-toggle="collapse" data-target={'#' + colapseID} aria-expanded="true" aria-controls={colapseID}>{dane.nazwa}</button></h2>
        </div>

        <div id={colapseID} class="collapse" aria-labelledby={headID} >
          <div class="card-body">
            <span className='d-flex mb-3'>{dane.opis}</span>
            <div className='d-flex flex-column'>
              <PanelBody token={token} dane={dane} years={years} refreshKonfig={this.props.refreshKonfig} />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
    )
  }
}



export class PanelBody extends React.Component {

  constructor() {
    super();

    this.state = {
      savingData: false,
      value: null,
      year: 0,
      add: false,
    };
  }

  componentDidMount() {
    const avYears = this.props.years.filter(year => {
      return !this.props.dane.wartosc?.some(val => String(val.year) === year);
    });
    this.setState({ avYears : avYears });
  }

  saveData(value, year) {
    this.setState({ savingData: true });

    axios.post(apiurl + "api/ewConfig", {
        id: this.props.dane.id,
        value: value ? value : this.state.value,
        year: year ? year : this.state.year,
      }, {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.props.token } })
      .then(res => {
        swal('Zapisano.');
        this.setState({ savingData: false });
        this.props.refreshKonfig();
      })
      .catch(error => {
        swal(error.response.data);
        this.setState({ savingData: false });
      });
  }

  deleteIdx(id, value, year) {
    this.setState({ savingData: true });

    axios.delete(apiurl + "api/ewConfig", { params: { 
        id: id,
        value: value,
        year: year
      }, headers: { 'Authorization' : "Bearer " + this.props.token } })
      .then(res => {
        swal('Usunięto.');
        this.setState({ savingData: false });
        this.props.refreshKonfig();
      })
      .catch(error => {
        swal(error.response.data);
        this.setState({ savingData: false });
      });
  }


 
  render() {

    const { dane } = this.props;
    const { savingData, add, avYears, value } = this.state;

    if(dane.ddl !== null && dane.czyDoRoku === false) {
      return (<div className='d-flex flex-row'>
        <select class="form-control w-auto" value={value ? value : dane?.wartosc[0] ? dane.wartosc[0].value : ""} onChange={(e) => (this.setState({ year: 0, value: e.target.value }))}>
          <option value="" disabled hidden>Wybierz</option>
          {dane.ddl?.map((val, idx) => <option key={idx} value={val} >{val}</option>)}
        </select>
        <button type="button" class="btn btn-light ml-2" disabled={savingData} onClick={() => (this.saveData())}>Zapisz</button>
        {savingData && <center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>}
      </div>)
    }

    else if(dane.ddl !== null && dane.czyDoRoku === true) {
      return (<div className='d-flex flex-column'>
        {dane.wartosc.map((wart, indx) => {
          return (<div className='d-flex flex-row mt-2 align-items-center' id={indx}>
            <DdlPanel token={this.props.token} idx={indx} id={dane.id} yearProps={wart.year} valueProps={wart.value} ddl={dane.ddl} refreshKonfig={this.props.refreshKonfig} />
            <i class="fa fa-trash ml-2 pointer" onClick={() => (this.deleteIdx(dane.id, wart.value, wart.year))}></i>
            {savingData && <center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>}
          </div>)
        })}
        {avYears?.length > 0 && (add ? <div className='d-flex flex-row mt-2 align-items-center' idx="dodaj" >
          <select class="form-control w-auto" onChange={(e) => (this.setState({ yearAdd: e.target.value }))}>
            <option disabled selected>Wybierz</option>
            {avYears?.map(val => <option>{val}</option>)}
          </select>
          <select class="form-control w-auto ml-2" onChange={(e) => (this.setState({ valueAdd: e.target.value }))}>
            <option disabled selected>Wybierz</option>
            {dane.ddl?.map(val => <option>{val}</option>)}
          </select>
          <button type="button" class="btn btn-light ml-2" disabled={savingData} onClick={() => (this.saveData(this.state.valueAdd, this.state.yearAdd))}>Zapisz</button>
          {savingData && <center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>}
        </div> : <i class="fa fa-plus ml-1 mt-1" onClick={() => (this.setState({ add: true }))}></i>)}
      </div>)
    }

    else if(dane.ddl === null && dane.czyDoRoku === false) {
      return (<div className='d-flex flex-row'>
        <input className='form-control' value={value ? value : dane?.wartosc?.[0]?.value ? dane?.wartosc?.[0]?.value : ""} onChange={(e) => (this.setState({ year: 0, value: e.target.value }))}/>
        <button type="button" class="btn btn-light ml-2" disabled={savingData} onClick={() => (this.saveData())}>Zapisz</button>
        {savingData && <center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>}
      </div>) 
    }

    else if(dane.ddl === null && dane.czyDoRoku === true) {
      return (<div className='d-flex flex-column'>
        {dane.wartosc.map((wart, indx) => {
          return (<div className='d-flex flex-row mt-2 align-items-center' id={indx}>
            <span>{wart.year}</span>
            <input className='form-control w-auto ml-2' onChange={(e) => (this.setState({ year: wart.year, value: e.target.value }))}/>
            <button type="button" class="btn btn-light ml-2" disabled={savingData} onClick={() => (this.saveData())}>Zapisz</button>
            {savingData && <center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>}
          </div>)
        })}
        {avYears?.length > 0 && (add ? <div className='d-flex flex-row mt-2 align-items-center' idx="dodaj" >
          <select class="form-control w-auto" onChange={(e) => (this.setState({ yearAdd: e.target.value }))}>
            <option disabled selected>Wybierz</option>
            {avYears?.map(val => <option>{val}</option>)}
          </select>
          <input class="form-control w-auto ml-2" type="text"  onChange={(e) => (this.setState({ value: e.target.value }))} />
          <button type="button" class="btn btn-light ml-2" disabled={savingData} onClick={() => (this.saveData(this.state.valueAdd, this.state.yearAdd))}>Zapisz</button>
          {savingData && <center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>}
        </div> : <i class="fa fa-plus" onClick={() => (this.setState({ add: true }))}></i>)}
      </div>)
    }

    else {
      return (<span>Brak konfiguracji</span>)
    }

  }

}

export class DdlPanel extends React.Component {

  constructor(props) {
    super();

    this.state = {
      savingData: false,
      value: props.valueProps ? props.valueProps : null,
      year: props.yearProps ? props.yearProps : 0,
    };
  }

  saveData(value, year) {
    this.setState({ savingData: true });
    axios.post(apiurl + "api/ewConfig", {
        id: this.props.id,
        value: value,
        year: year,
      }, {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.props.token } })
      .then(res => {
        swal('Zapisano.');
        this.setState({ savingData: false });
        this.props.refreshKonfig();
      })
      .catch(error => {
        swal(error.response.data);
        this.setState({ savingData: false });
      });
  }

  render() {
    const { ddl, yearProps, valueProps } = this.props;
    const { value, savingData } = this.state;

    return(<>
      <span>{yearProps}</span>
      <select class="form-control w-auto ml-2"  value={value ? value : valueProps} onChange={(e) => (this.setState({ year: yearProps, value: e.target.value }))}>
        <option value="" disabled hidden>Wybierz</option>
        {ddl?.map((val, idx) => <option key={idx} value={val} >{val}</option>)}
      </select>
      <button type="button" class="btn btn-light ml-2" disabled={savingData} onClick={() => (this.saveData(this.state.value, this.state.year))}>Zapisz</button>
    </>)
  }
}
